import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Column } from "rbx";
import BooleanInput from "../inputs/BooleanInput";

import { ALL_USER_GROUPS_QUERY } from "../../graphql/UserGroups/UserGroups.graphql";
import { ourToast as toast } from "../../utils";

const UserGroupMembershipCheckGroup = ({ inputs, readOnly, onChange }) => {
  const { data, loading, error } = useQuery(ALL_USER_GROUPS_QUERY, {
    variables: { orderByMulti: ["Name_ASC"] }
  });
  if (error) {
    toast.error("Error getting User Groups.");
  }
  if (loading || !data?.UserGroups) return <p>Loading</p>;

  return (
    <Field multiline kind="group">
      {data.UserGroups.map(group => (
        <Column size={4}>
          <Column.Group>
            <Column size={3}>
              <Control key={group.GroupId}>
                <BooleanInput
                  name={group.RecId}
                  readOnly={readOnly}
                  value={inputs[group.RecId]}
                  onChange={e => onChange(e, group)}
                />
              </Control>
            </Column>
            <Column size={9}>
              <Label style={{ flex: "none", marginTop: 5 }}>{group.Name}</Label>
            </Column>
          </Column.Group>
        </Column>
      ))}
    </Field>
  );
};

UserGroupMembershipCheckGroup.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};
UserGroupMembershipCheckGroup.defaultProps = {
  inputs: {}
};
export default UserGroupMembershipCheckGroup;
